export default __webpack_public_path__ + "static/media/manga_bold.d5130db7.otf";